module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner prdEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [(_vm.sort == 2) ? _c('span', [_vm._v("新建产品")]) : _vm._e(), _vm._v(" "), (_vm.sort == 3) ? _c('span', [_vm._v("新建服务")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "inline-message": "true",
      "show-message": true
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("分类")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "productServiceCategoryId"
    }
  }, [(_vm.sort == 2) ? _c('dic-select', {
    attrs: {
      "code": "cpfl",
      "selectId": _vm.params.productServiceCategoryId,
      "paramsKey": "productServiceCategory",
      "plaText": "分类"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sort == 3) ? _c('dic-select', {
    attrs: {
      "code": "fwfl",
      "selectId": _vm.params.productServiceCategoryId,
      "paramsKey": "productServiceCategory",
      "plaText": "分类"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("标题")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.sort == 2) ? _c('span', [_vm._v("产品介绍")]) : _vm._e(), _vm._v(" "), (_vm.sort == 3) ? _c('span', [_vm._v("服务介绍")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('textEditor', {
    ref: "textEditor",
    attrs: {
      "inContent": _vm.params.content
    },
    on: {
      "onchange": _vm.contentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("所属企业")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-select', {
    staticClass: "inpText",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "reserve-keyword": "",
      "placeholder": "输入企业名称",
      "remote-method": _vm.eprSeek
    },
    on: {
      "change": _vm.eprSelect
    },
    model: {
      value: (_vm.params.publishCompanyId),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishCompanyId", $$v)
      },
      expression: "params.publishCompanyId"
    }
  }, _vm._l((_vm.selectArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("联系人")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contactPerson"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params.contactPerson),
      callback: function($$v) {
        _vm.$set(_vm.params, "contactPerson", $$v)
      },
      expression: "params.contactPerson"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("联系电话")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "contactPhone", $$v)
      },
      expression: "params.contactPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("头部图")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('imgs-upload', {
    attrs: {
      "files": _vm.params.coverImage,
      "tips": "（375*200推荐）"
    },
    on: {
      "fileChange": _vm.imgChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block tag-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('tag-select', {
    attrs: {
      "selectTags": _vm.params.tagNames,
      "paramsKey": "tagNames"
    },
    on: {
      "selectChange": _vm.tagChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block radio-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("审核")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("不通过")])], 1)], 1)])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.directSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-9750c0f6"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/message/prdEdit.vue
// module id = 1545
// module chunks = 1